import getPageName from "./getPageName";
import initCompleteModal from "./modal/init-complete-modal";

const initBanner = (PROGRAMS) => {
  const banner = document.querySelector(".banner-set"),
    form = document.querySelector(".form"),
    home = document.querySelector(".home");

  if (!banner || !form || !home) return;

  const trackScroll = () => {
    const scrolled = window.pageYOffset;
    
    if (scrolled < home.offsetTop + home.clientHeight) {
      banner.style.transform = "translateY(170%)";
    } else if (
      scrolled + document.documentElement.clientHeight >
      form.offsetTop
    ) {
      banner.style.transform = "translateY(170%)";
    } else if (scrolled < form.offsetTop) {
      banner.style.transform = "translateY(0)";
    }
  };

  /* Отображение текста для активной или выключенной программы */
  (() => {
    const url = location.href.split('/');

    if (url.includes('program')) {     
      if (PROGRAMS.some(program => program.shortname === getPageName())) {
        banner.querySelector('.active').style.display = 'flex';  

        if (form.querySelector('.spinner-content')) {
          form.querySelector('.active').style.display = 'block';
          form.querySelector('.spinner-content').classList.remove('spinner-content');
        }
      } else {
        banner.querySelector('.not-active').style.display = 'flex';

        if (form.querySelector('.spinner-content')) {
          form.querySelector('.not-active').style.display = 'block';
          form.querySelector('.spinner-content').classList.remove('spinner-content');
        }

        initCompleteModal();
      }     

      window.addEventListener("scroll", trackScroll);     
    } else {    
      banner.querySelector('.active').style.display = 'flex';

      if (form.querySelector('.spinner-content')) {
        form.querySelector('.active').style.display = 'block';
        form.querySelector('.spinner-content').classList.remove('spinner-content');
      }

      window.addEventListener("scroll", trackScroll);
    }
  })();
};

export default initBanner;
